import { convert } from 'html-to-text';

const HEADING_SELECTORS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

function convertHtmlToText(html, { preserveCase = false } = {}) {
  const options = {
    wordwrap: false,
    selectors: [
      { selector: 'img', format: 'skip' },
      {
        selector: 'p',
        options: { leadingLineBreaks: 1, trailingLineBreaks: 1 },
      },
      ...(preserveCase
        ? HEADING_SELECTORS.map((selector) => ({
            selector,
            format: 'heading',
            options: { uppercase: false },
          }))
        : []),
    ],
  };

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const updatedHtml = doc.body.innerHTML;
  const text = convert(updatedHtml, options);

  return text;
}

export default convertHtmlToText;
